import { AccountType } from "@/services/user/userTypes";

export enum ThirdPartyLoginStatus {
  // API response codes
  Ok = 1,
  DifferentAccountType = 2,
  AccountInactive = 3,
  WrongData = 4,
}

export enum LoginProvider {
  Google = AccountType.Google,
  Facebook = AccountType.Facebook,
}
